<template>
  <div class="publish-homework">
    <el-tabs v-model="tabName" type="border-card">
      <el-tab-pane name="发布作业" label="发布作业">
        <publishHomeworkMain
          @publishHomework="publishHomework"
          :className="className"
          :classPlaceholder="classPlaceholder"
          :classProps="classProps"
          :classSelect="classSelect"
          :classInfoArr="classInfoArr"
          :courseList="courseList"
          @getCourseList="selectCourseList"
        />
      </el-tab-pane>
      <el-tab-pane name="我发布的作业" label="我发布的作业"
        ><myPublishedHomework
          :getHomeworkListResult="getHomeworkListResult"
          :homeworkList="homeworkList"
          :total="total"
          @currentMyPublishHomeworkList="currentMyPublishHomeworkList"
          @currentMyPublishHomeworkListPageSize="handleSizeChange"
      /></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import publishHomeworkMain from "./components/publish-homework-main/publishHomeworkMain.vue";
import myPublishedHomework from "./components/publish-homework-my-published/myPublishedHomework.vue";
export default {
  components: {
    publishHomeworkMain,
    myPublishedHomework,
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 20,
      total: 0,
      homeworkList: [],
      getHomeworkListResult: "nullData",
      tabName: "发布作业",
      // 处理后的班级年级多选数据
      classSelect: [],
      // 级联选择器属性配置
      classProps: {
        expandTrigger: "hover",
        children: "schoolClassList",
      },
      // 选中后的班级年级
      className: [],
      // 班级年级数据
      classSelectList: [],
      classPlaceholder: "请选择班级",
      classData: {
        classId: "",
        className: "",
      },
      classInfoArr: [],
      courseList: [],
      semester: "",
      schoolYear: "",
      semesterOptions: [],
    };
  },
  created() {
    this.selectSchoolAndGradeAndClassListPC();
    // this.getMyPublishHomeworkList();
  },
  methods: {
    publishHomework() {
      this.tabName = "我发布的作业";
      this.getMyPublishHomeworkList();
    },
    currentMyPublishHomeworkList(e) {
      this.pageNum = e;
      this.getMyPublishHomeworkList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getMyPublishHomeworkList();
    },
    // 年级和班级选择列表
    selectSchoolAndGradeAndClassListPC() {
      this.get(this.$url.getgradeList, {
        schoolId: this.user.schoolId,
      })
        .then((res) => {
          if (res.code !== 200) {
            return this.$message.error(res.msg);
          }
          // console.log(res);
          this.classSelectList = res.data;
          this.classSelectListLength = this.classSelectList.length;
          // console.log(this.classSelectList.length);
          if (this.classSelectList.length) {
            this.classSelectList.forEach((gItem, g) => {
              let { gradeCode, gradeId, gradeName } = gItem;
              gItem.value = {
                gradeCode,
                gradeId,
                gradeName,
              };
              gItem.label = gItem.gradeName;
              gItem.schoolClassList.forEach((cItem, c) => {
                let { classCode, classId, className } = cItem;
                cItem.value = {
                  classCode,
                  classId,
                  className,
                };
                cItem.label = cItem.className;
              });
            });
            this.classSelect = this.classSelectList;
            // // 默认选中时的classId/className
            // this.classData.classId = this.classSelect[0].schoolClassList[0].classId;
            // this.classData.className = this.classSelect[0].schoolClassList[0].className;
            this.classInfoArr = [
              {
                gradeCode: this.classSelect[0].gradeCode,
                gradeId: this.classSelect[0].gradeId,
                gradeName: this.classSelect[0].gradeName,
              },
              {
                classCode: this.classSelect[0].schoolClassList[0].classCode,
                classId: this.classSelect[0].schoolClassList[0].classId,
                className: this.classSelect[0].schoolClassList[0].className,
              },
            ];

            // 默认选中第一个年级班级
            let firstGrade = {};
            let { gradeCode, gradeId, gradeName } = this.classSelect[0];
            firstGrade = { gradeCode, gradeId, gradeName };
            let firstClass = {};
            let {
              classCode,
              classId,
              className,
            } = this.classSelect[0].schoolClassList[0];
            firstClass = { classCode, classId, className };
            // this.className = [firstGrade, firstClass];
            // this.classPlaceholder = `${firstGrade.gradeName} / ${firstClass.className}`;
            // console.log("处理后的数据==>", this.classSelect);

            // 获取学生列表
            this.getMyPublishHomeworkList();
            this.getCourseList();
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$message.error("获取班级列表失败");
        });
    },
    selectCourseList(e) {
      if (!e) return;
      this.classInfoArr = e;
      this.getCourseList();
    },
    getCourseList() {
      this.isLoading = true;
      this.get(this.$url.selectTeacherCourse, {
        teacherId: this.user.id,
        classId: this.classInfoArr[1].classId,
      })
        .then((res) => {
          this.isLoading = false;
          if (res.code != 200) {
            return this.$message.error("获取科目列表失败");
          }
          this.courseList = res.data;
          // console.log("科目列表==>", this.courseList);
        })
        .catch((err) => {
          this.isLoading = false;
          this.$message.error("获取科目列表失败");
        });
    },
    getMyPublishHomeworkList() {
      // this.getHomeworkListResult = "loading";
      this.get(this.$url.selectTeacherHomeworkList, {
        teacherId: this.user.id,
        // classId: this.classData.classId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      })
        .then((res) => {
          // console.log("获取作业列表==>", res);
          if (res.code != 200) {
            this.getHomeworkListResult = "error";
            return this.$message.error(res.msg);
          }

          this.homeworkList = res.rows;
          this.total = res.total;
          this.homeworkList.length == 0
            ? (this.getHomeworkListResult = "nullData")
            : (this.getHomeworkListResult = "success");
          // console.log(this.getHomeworkListResult);
        })
        .catch((err) => {
          // console.log(err);
          // console.log(this.getHomeworkListResult);
          this.total == 0
            ? (this.getHomeworkListResult = "nullData")
            : (this.getHomeworkListResult = "success");
          // this.getHomeworkListResult = "error";
          // this.$message.error("获取作业列表失败");
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "./publishHomework.scss";
</style>
